export default {"src":"/_next/static/media/arrow-right.b5408dff.svg","height":18,"width":16};